export default __webpack_public_path__ + "static/media/Vambraces of the Black Pharaoh.fabe8fe2.jpg";